module.exports = __webpack_public_path__ + "img/11400.db1c63e4.jpg";